import { graphConfig } from '@/config/authConfig'
import axios from 'axios'

export const getUserDetails = async (graphToken: string | null) => {
  const { data, status, statusText } = await axios.get(
    `${graphConfig.graphMeEndpoint}?$select=${graphConfig.selectProperties}`,
    {
      headers: {
        Authorization: `Bearer ${graphToken}`,
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
      },
    },
  )
  return {
    data,
    status,
    statusText,
  }
}

export const getUserProfile = async (graphToken: string | null) => {
  const { data, status, statusText } = await axios.get(`${graphConfig.graphMeEndpoint}/photo/$value`, {
    headers: {
      Authorization: `Bearer ${graphToken}`,
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'image/jpeg',
    },
    responseType: 'arraybuffer',
  })
  return {
    data,
    status,
    statusText,
  }
}
